

import Header from "../components/header";
import Footer from "../components/footer";
import AnimatedText from "../components/animation";
import FadeInOnScroll from "../components/scrollanimation";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Lenis from 'lenis'

// image
import whatsappIcon from '../assets/whatsapp-icon.png'
import allyhome from '../assets/ally-big.webp'
import needanswersfast from '../assets/Needanswersfast.webp'
import howallyeasier from '../assets/HowAllyEasier.webp'
import WhyEveryoneLovesAlly from '../assets/Why-Everyone-Loves-Ally.webp'
import AllyCanDoToday from '../assets/AllyCanDoToday.webp'
import Allydelivers from '../assets/Ally-delivers-real-world-results.webp'


function Home() {
  
  const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
  return (
    <div id="smooth-wrapper">
      <Header />

      <Col className="top-header bg-fffaed col-form-label-lg d-sm-flex justify-content-sm-center align-items-sm-center">
        Scaling Support on a Budget? Try ally’s WhatsApp-First Solution with a Smart AI Agent.
        <a className="fw-semibold green-text" href="#">Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
          <path fillRule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
        </svg></a>
      </Col>

      <main>
        <section className="hero">
          <Container>

            <Row>
              <Col>
                <FadeInOnScroll yOffset={100}>
                  <img src={allyhome} alt="ally" className="img-fluid" />
                </FadeInOnScroll>

              </Col>
              <Col className="text-start d-sm-flex justify-content-sm-center align-items-sm-center">
                <div className="col-8">
                  <h1 className="h1 hero-family">
                    <AnimatedText text="Grow your business" animationType="fade-up" />

                    <br /> <AnimatedText text="on" animationType="fade-up" /><b className="green-text"> <AnimatedText text="WhatsApp" animationType="fade-up" /></b></h1>
                  <p>
                    <AnimatedText text="Boost engagement and streamline communication with Ally—your AI-powered assistant that automates HR, support, and daily tasks, making interactions faster, smarter, and more personal." animationType="rotate" />
                  </p>
                  <FadeInOnScroll yOffset={100}>
                    <a className="button" href="/register">Free 7 day trial <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                      <path fillRule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                    </svg></a>
                    <a className="text-button fw-semibold" href="/register">Book a Demo Today <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                      <path fillRule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                    </svg></a>
                  </FadeInOnScroll>

                </div>

              </Col>
            </Row>


          </Container>

        </section>

        <section className="section bg-fffaed py-5 radius-6rem">
          <Container className="py-5">
            <Row>
              <Col className="d-sm-flex justify-content-sm-center align-items-sm-center">
                <div className="col-8">
                  <h2 className="h1 hero-family"> <AnimatedText text="Need answers fast?" animationType="fade-up" /><br />
                    <AnimatedText text="Ally’s here to help!" animationType="fade-up" /></h2>

                  <p>
                    <AnimatedText text="Ally is your smart, friendly chatbot that solves problems instantlywhether you’re an employee, manager, or just busy at work. No waiting, no stress!" animationType="rotate" />
                  </p>
                </div>

              </Col>
              <Col>
                <FadeInOnScroll yOffset={100}><img src={needanswersfast} alt="ally" className="img-fluid" /></FadeInOnScroll>

              </Col>
            </Row>
          </Container>

        </section>


        <section className="section">
          <Container className="py-5">
            <Row>

              <Col>
                <FadeInOnScroll yOffset={100}>
                  <img src={howallyeasier} alt="ally" className="img-fluid" />
                </FadeInOnScroll>

              </Col>

              <Col className="text-start d-sm-flex justify-content-sm-center align-items-sm-center">
                <div className="col-10">

                  <FadeInOnScroll yOffset={120}>
                    <h3 className="h1 hero-family mb-4">How Ally Makes Life Easier</h3>
                    <p>
                      💬 Ask anything → Get instant answers! <br /><br />
                      📌 Update info, check benefits – no emails!  <br /><br />
                      🌱 Personalized tips to grow skills   <br /><br />
                      ⏳ Saves time, cuts costs, zero errors <br /><br />
                      💡 Get instant answers to work questions, update info hassle-free, and grow your skills—all in one place. Saves time, cuts costs, and eliminates errors. Work smarter, not harder! ⚡
                    </p>
                  </FadeInOnScroll>

                </div>

              </Col>
            </Row>
          </Container>

        </section>


        <section className="section  bg-fffaed py-5 radius-6rem">
          <Container className="py-5">
            <Row>
              <Col className="text-start d-sm-flex justify-content-sm-center align-items-sm-center">
                <div className="col-10">
                  <FadeInOnScroll yOffset={120}>
                    <h3 className="h1 hero-family mb-4">Why Everyone Loves Ally</h3>
                    <p>
                      ✅ Simple "Type like texting a friend - no manuals!"  <br /><br />
                      🌙 Always On "2 AM emergency? Ally's awake!"  <br /><br />
                      🔐 Safe & Private "GDPR & HIPAA compliant"  <br /><br />
                      🔄 Fits Anywhere "Works in Slack, HR systems & more"
                    </p>
                  </FadeInOnScroll>

                </div>

              </Col>
              <Col>
                <FadeInOnScroll yOffset={100}>
                  <img src={WhyEveryoneLovesAlly} alt="ally" className="img-fluid" />
                </FadeInOnScroll>

              </Col>


            </Row>
          </Container>

        </section>


        <section className="section">
          <Container className="py-5">
            <Row>

              <Col>
                <FadeInOnScroll yOffset={100}>
                  <img src={AllyCanDoToday} alt="ally" className="img-fluid" />
                </FadeInOnScroll>

              </Col>

              <Col className="text-start d-sm-flex justify-content-sm-center align-items-sm-center">
                <div className="col-10">
                  <FadeInOnScroll yOffset={120}>
                    <h3 className="h1 hero-family mb-4">Ally Can Do This Today</h3>
                    <p>
                      🔹 New Hire? Ally guides you through onboarding.<br /><br />
                      🔹 Confused about policies?  Ally explains in plain language.<br /><br />
                      🔹 Want to learn? Ally suggests courses you’ll love.<br /><br />
                      🔹 Feedback? Ally collects it—no surveys needed!<br /><br />
                    </p>
                  </FadeInOnScroll>

                </div>

              </Col>
            </Row>
          </Container>

        </section>


        <section className="section  bg-fffaed py-5 radius-top-6rem">
          <Container className="py-5">
            <Row>
              <Col className="text-start d-sm-flex justify-content-sm-center align-items-sm-center">
                <div className="col-10">
                  <FadeInOnScroll yOffset={120}>
                    <p className="mb-4">
                      <b>Ally delivers real-world results, </b> helping teams get answers 80% faster than emailing HR and reducing time wasted on small questions by 30%. With over 90% of people preferring Ally over waiting, it’s the smart choice for streamlining workplace communication.
                    </p>
                  </FadeInOnScroll>

                  <FadeInOnScroll yOffset={120}>
                    <p>
                      <b>Getting started with Ally</b> is simple. First, connect it to your existing systems or start fresh. Then, teach Ally by sharing your FAQs—it learns quickly. Finally, go live with stress-free support from our team. In just three easy steps, you’ll have a powerful tool to boost efficiency and satisfaction.
                    </p>
                  </FadeInOnScroll>

                </div>

              </Col>
              <Col>
                <FadeInOnScroll yOffset={100}>
                  <img src={Allydelivers} alt="ally" className="img-fluid" />
                  <a className="button" href="/register">Work smarter with Ally! ⚡</a>
                </FadeInOnScroll>

              </Col>


            </Row>
          </Container>

        </section>

      </main>
      <Footer />

      <a
        href="https://wa.me/919036455201?text=Hi%2C%20I%27d%20like%20to%20know%20more%20about%20Ally."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        title="Chat with us on WhatsApp"
      >
        <img src={whatsappIcon} alt="WhatsApp" />
      </a>
    </div>
  );
}

export default Home;